try {
  (() => {
    if (window.globalThis) {
      return;
    }
    window.globalThis = window;
  })();

  console.log('[Polyfills] globalThis polyfill added.');
} catch (err) {
  console.error('[Polyfills] Unable to polyfill globalThis', err);
}
